export default __webpack_public_path__ + "static/media/DisableResult.2bd40ead.svg";